import styled from '@emotion/styled'

const BgImage = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export default BgImage
